<h2>
  {{'world_record' | transloco}}: &nbsp;
  <span>{{
    (
    filter_service.comboCategoryStore?.comboData
    | async
    )?.CatName
    }}

    {{
      (filter_service.comboCategoryStore?.comboData | async)?.CatName
        ? (
            filter_service.comboCategoryStore.individualTeamComboRef.comboData
            | async
          ).Name
        : ""
    }}
  </span>
</h2>
<table class="wa-table">
  <thead class="wa-table__header-group">
    <tr class="wa-table__row">
      <th
        class="h-ranking sortable wa-table__cell"
        [ngClass]="sortClass('RECORD')"
        (click)="changeSort('RECORD')"
      >
        <span>{{ "Record" | transloco }}</span>
      </th>
      <th
        class="h-name sortable wa-table__cell"
        [ngClass]="sortClass('NAME')"
        (click)="changeSort('NAME')"
      >
        <span>
          {{
            (
              filter_service.comboCategoryStore.individualTeamComboRef.comboData
              | async
            )?.Name === "Individual"
              ? "Name"
              : "Team"
          }}
        </span>
      </th>
      <th
        class="h-name wa-table__cell"
        *ngIf="
          (
            filter_service.comboCategoryStore.individualTeamComboRef.comboData
            | async
          )?.Name !== 'Individual'
        "
      >
        <span>{{ "Competition" | transloco }}</span>
      </th>
      <th
        *ngIf="
          (
            filter_service.comboCategoryStore.individualTeamComboRef.comboData
            | async
          )?.Name === 'Individual'
        "
        class="h-team sortable wa-table__cell"
        class="h-points sortable wa-table__cell"
        [ngClass]="sortClass('DATE')"
        (click)="changeSort('DATE')"
      >
        <span>{{ "Date" | transloco }}</span>
      </th>
      <th
        class="h-points sortable wa-table__cell"
        [ngClass]="sortClass('COUNTRY')"
        (click)="changeSort('COUNTRY')"
      >
        <span>{{ "Score" | transloco }}</span>
      </th>
    </tr>
  </thead>
  <ng-container *ngIf="RankingsList.length > 0; else noresults">
    <tbody
      class="wa-table__row-group"
      *ngFor="let ranking of RankingsList"
      [Ranking]="ranking"
      app-world-records-item
      class="wa-table__row-group"
    >
      <!--<app-world-records-item appRemoveTag class="wa-table__row-group"
  ></app-world-records-item>-->
    </tbody>
  </ng-container>
  <ng-template #noresults>
    <tbody class="wa-table__row-group">
      <div
        *ngIf="loading === false"
        class="status-message status-message--info"
      >
        {{ "no_results" | transloco }}
        {{ defaultValueMessage | async | transloco }}
      </div>
    </tbody>
  </ng-template>
</table>

<div
  class="status-message status-message--info"
  *ngIf="loading === true; else button"
  class="loading-throbber"
></div>
<ng-template #button>
  <div
    [ngClass]="'load-more-full'"
    *ngIf="
      RankingView !== undefined && RankingsList.length < RankingView.totalItems
    "
    (click)="loadMore()"
  >
    {{ "load_more" | transloco }}
  </div>
</ng-template>

<hr class="spacer" />
<div class="block-ads-wrapper">
  <app-world-records-broken-panel></app-world-records-broken-panel>
  <app-google-ads [type]="'double_click_WA100_2'"></app-google-ads>
</div>
<!--
<div *ngIf="loading===false && RankingList!==undefined &&  RankingList.length===0" class="status-message status-message--info">{{'no_results' | transloco}}</div>
<ng-template *ngIf="loading===true" #noresults> <div class="status-message status-message--info">{{'no_results' | transloco}}</div> </ng-template>
-->
